import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  currentLanguage: "EN",
  pageBreadCrumb: [],
};

const LanguageSlice = createSlice({
  name: "LanguageSlice",
  initialState,
  reducers: {
    updateLanguage: (state, action) => {
      state.currentLanguage = action.payload;
    },
    setPageBreadCrumb: (state, action) => {
      state.pageBreadCrumb = action.payload;
    },
  },
});

export const { updateLanguage, setPageBreadCrumb } = LanguageSlice.actions;
export default LanguageSlice.reducer;
